import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
};

const StarBlack: React.FC<Props> = ({ className, width = '16', height = '16' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0L10.472 5.26604L16 6.11567L12 10.2124L12.944 16L8 13.266L3.056 16L4 10.2124L0 6.11567L5.528 5.26604L8 0Z" fill="#0B1215" />
  </svg>
);

export default StarBlack;
